import { WaterlilyClient } from '@/api/waterlily';
import {
  AvailabilityResponse,
  IllustrationMonitorRunResponse,
  IllustrationMonitorStatus,
  MonitorCarrier,
  MonitorProduct,
  MonitorQuote,
  MonitorQuotesRequest,
  MonitorQuotesResponse,
  MonitorRequestsRequest,
  MonitorRequestsResponse,
  MonitorStateOption,
} from '@/features/illustration-monitor/types';

export const illustrationMonitorApi = {
  getCarriers: () =>
    WaterlilyClient.get<{ carriers: MonitorCarrier[] }>('/illustration-monitor-carriers'),

  getProducts: (insuranceCarrierId: number) =>
    WaterlilyClient.get<{ products: MonitorProduct[] }>(
      `/illustration-monitor-products/${insuranceCarrierId}`,
    ),

  getStates: (payload: { insuranceCarrierId: number; productNames: string[]; quoteType: string }) =>
    WaterlilyClient.post<{ states: MonitorStateOption[] }>('/illustration-monitor-states', payload),

  queryQuotes: (payload: MonitorQuotesRequest) =>
    WaterlilyClient.post<MonitorQuotesResponse>('/illustration-monitor-quotes-query', payload),

  queryRequests: (payload: MonitorRequestsRequest) =>
    WaterlilyClient.post<MonitorRequestsResponse>('/illustration-monitor-logs', payload),

  run: (quoteId: string, quoteType: string, clientState?: string) =>
    WaterlilyClient.post<IllustrationMonitorRunResponse>('/illustration-monitor-run', {
      quoteId,
      quoteType,
      clientState,
    }),

  getStatus: (requestId: string) =>
    WaterlilyClient.get<IllustrationMonitorStatus>(`/illustration-monitor-status/${requestId}`),

  getAvailability: () =>
    WaterlilyClient.get<AvailabilityResponse>('/illustration-monitor-availability'),

  getQuoteById: (quoteId: string) =>
    WaterlilyClient.get<{ quote: MonitorQuote | null }>(
      `/illustration-monitor-quote/${quoteId}`,
    ),
};
